import { render } from "./ConfirmDeleteClassModal.vue?vue&type=template&id=2947da58&ts=true"
import script from "./ConfirmDeleteClassModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteClassModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__